export const taxIdNumberLengthStrategy = (value: string) => {
  return value.length === 8;
};
